<template>
    <v-container id="logs-dialog">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

        <v-dialog v-model="dialog" persistent scrollable max-width="1200px" :fullscreen="$vuetify.breakpoint.mobile">

            <v-card max-height="900px" class="backdrop dialog-card">

                <v-overlay absolute :value="overlay_loading">
                    <v-progress-circular indeterminate :size="80" :width="7"
                                         color="secondary"></v-progress-circular>
                </v-overlay>

                <v-card-title class="backdrop lighten-1 dialog-title">
                    <span class="text-h5">INCIDENT LOGS</span>
                </v-card-title>
                <v-card-text class="backdrop pa-0 white--text">
                    <v-container>

                        <v-row class="mb-2 mx-2">
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" block @click="newLog"
                                   class="mx-auto my-5 black--text">
                                New Log
                                <v-icon right
                                        dark>
                                    $plus
                                </v-icon>
                            </v-btn>
                        </v-row>

                        <div v-if="!filteredData || filteredData.length == 0" class="mx-auto text-h6 text-center">No Logs Found</div>
                        <div v-for="(log,index) in filteredData" :key="index" class="backdrop lighten-1 pa-3 mt-0 mb-2 mx-4 elevation-1">

                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <div class="text-h7 "> NAME : {{log.fullname}}</div>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <div class="text-h7"> DATE CREATED : {{formatDate(log.s_createdate)}}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea maxlength="4000" label="LOG ENTRY" v-model="log.log" height="175" outlined></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-btn color="secondary" class="text-end" @click="deleteLog(index)">
                                        <v-icon color="black">$del</v-icon>
                                    </v-btn>
                                </v-col>

                            </v-row>



                        </div>

                    </v-container>
                    <!--<small class="mx-4">*indicates required fields</small>-->
                </v-card-text>

                <v-card-actions class="backdrop lighten-1 border-card">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" class="black--text"
                           @click="closeDialog">
                        Close
                    </v-btn>
                    <v-btn color="secondary" class="black--text"
                           @click="SaveLogs">
                        Save
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

    </v-container>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";

    .dialog-card {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    }

    .dialog-title {
        margin-bottom: 2px;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    }

    .custom-divider {
        height: 2px;
        background-color: black;
    }

    .border-card {
        margin: 2px;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "logs-dialog",
        mixins: [bus_common],
        props: ["logs_dialog_ID"],
        data() {
            return {
                log_records: [],
                dialog: true,
                valid: false,
                overlay_loading: false,
                field_rules: {
                    required: value => !!value || 'This field is required',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    max25: v => v.length <= 60 || 'Max 60 characters',
                    email: value => {
                        const pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        return pattern.test(value) || 'Please provide a valid email address'
                    },
                    min_phone: v => v.length >= 14 || 'Please enter a complete phone number',
                    phone: value => {
                        const pattern = /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
                        return pattern.test(value) || 'Please provide a valid phone number'
                    },
                    filerequired: value => !!value || 'A signature image is required',

                },
                user_record: {
                    hitnrun_usersId: 0,
                    email_user: "",
                    proper_name: "",
                    title: "",
                    phone: "",
                    file: null,
                    file_sig_image: "",
                    s_del: "f",
                    s_user: "",
                    s_createuser: "",
                    s_createdate: "1900-01-01",
                    s_date: "1900-01-01"
                }
            };
        },
        methods: {
            customTitle() {
                if (this.field_user.hitnrun_usersId == 0)
                    return "NEW USER"
                else
                    return "EDITING A USER"
            },
            closeDialog() {
                this.dialog = false;
                setTimeout(() => {
                    this.$emit('closeDialog');
                }, 1000)

            },
            async init() {
                this.overlay_loading = true;
                await this.getUserData();
                await this.getLogData();
                this.overlay_loading = false;
            },
            async getUserData() {
                let form = {
                    email: this.$store.state.user.email
                };

                await this.$axios.post('api/hitnrunuser/getUserByEmail', form)
                    .then(response => {
                        this.user_record = response.data;
                    }).catch(error => {
                        if (error.response) {
                            //this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
            },
            async getLogData() {
                let form = {
                    hitrunID: this.logs_dialog_ID
                };
                await this.$axios.post('api/logs/GetLogs', form)
                    .then(response => {
                        this.log_records = response.data;
                        for (var i = 0; i < this.log_records.length; i++) {
                            this.UndoEmptyDateFix(this.log_records[i], 's_createdate');
                        }
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                        }
                    });
            },
            formatDate(date) {
                return this.$moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
            },
            newLog() {
                // Prior to log creation check we have a valid user created, if not deny access to create a log
                if (!this.user_record.hitnrun_usersId) {
                    this.swall_it("Error!", "In order create or edit logs you must have a valid user created within the Hit N Run app.", "error", null, null);
                }
                else {
                    let newLog = {
                        log_entryId: 0,
                        hitnrun_usersId_log_entryId: this.user_record.hitnrun_usersId,
                        hitrunID_log_entryId: this.logs_dialog_ID,
                        fullname: this.user_record.proper_name,
                        log: "",
                        s_del: "f",
                        s_user: this.$store.state.user.email,
                        s_createdate: this.$moment(new Date()).format("YYYY-MM-DD"),
                        s_date: "1900-01-01"
                    }
                    this.log_records.push(newLog)
                }


            },
            deleteLog(index) {
                this.filteredData[index].s_del = "t";
            },
            formatDateFix(object, propname) {
                if (object[propname] != "")
                    object[propname] = this.$moment(new Date(object[propname])).format("YYYY-MM-DD")
            },
            UndoEmptyDateFix(object, propname) {
                if (object[propname] == '0001-01-01T00:00:00' || object[propname] == "1900-01-01T00:00:00")
                    object[propname] = ""
                else {
                    object[propname] = this.$moment(object[propname]).format("YYYY-MM-DD")
                }
            },
            async SaveLogs() {
                this.overlay_loading = true;
                let logscopy = JSON.parse(JSON.stringify(this.log_records));
                for (var i = 0; i < logscopy.length; i++) {
                    this.formatDateFix(logscopy[i], 's_createdate');
                }

                let form = {
                    log_entries: logscopy,
                    hitrunID: this.logs_dialog_ID,
                    user_email: this.$store.state.user.email,
                };
                await this.$axios.post('api/logs/SaveLogs', form)
                    .then(response => {
                        this.overlay_loading = false;
                        let callback = () => { this.closeDialog(); }
                        this.swall_it("Logs Saved! ", "The logs were successfully saved.", "success", callback, null);
                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.overlay_loading = false;
                        }
                    });
            }
        },
        computed: {
            filteredData() {
                if (this.log_records) {
                    if (this.log_records.length > 0) {
                        return this.log_records.filter(x => x.s_del == "f");
                    }
                }

            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
